/*
  Enter num campo faz o mesmo que clicar no botão principal do formulário.

  O MainButton e o SecondaryButton são de tipo `button`, então o `<form>` não tem botão de submit
  e o navegador não envia ao apertar Enter. Este handler faz esse papel, com as regras do envio
  nativo:
  - só o Enter dado num `<input>` dentro do próprio formulário conta. Num textarea ele quebra
    linha, e num botão ou link focado ele aciona o próprio elemento;
  - o Enter que outro componente já tratou (com `preventDefault`) não conta. A caixa do `Select`
    é um botão, então o Enter nela abre a lista, e a busca da lista fica num portal, fora do
    `<form>`;
  - o Enter dado num diálogo aberto de dentro do formulário também não. O Dialog do @cutilei/ui
    desenha o diálogo num portal, fora do `<form>`, mas o React leva o evento pela árvore de
    componentes até este `onKeyDown`. Sem essa checagem, um Enter no diálogo de sucesso repetia o
    cadastro;
  - com o botão principal bloqueado, o Enter não faz nada, como um botão de submit desabilitado.
    É o que impede um Enter duplo de enviar duas vezes.

  O `preventDefault` impede que um formulário de campo único ainda faça o envio nativo, que
  recarregaria a página.

  Uso: <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
  A ação é a mesma do `onClick` do botão principal, e `blocked` é o mesmo `disabled` dele.
*/
export default function submitOnEnter(action, blocked = false) {
  return event => {
    if (event.key !== 'Enter' || event.isDefaultPrevented()) return
    if (event.target.tagName !== 'INPUT' || !event.currentTarget.contains(event.target)) return

    event.preventDefault()
    if (!blocked) action()
  }
}
